var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "store-selector mb-3" }, [
    _vm.stores && _vm.stores.length
      ? _c(
          "div",
          [
            _c("div", { staticClass: "mb-1" }, [
              _c("b", [_vm._v(_vm._s(_vm.title))]),
            ]),
            _vm._v(" "),
            _c(
              _setup.BDropdown,
              {
                ref: "storesDropdownRef",
                attrs: { text: _setup.storeUrl, split: "", variant: "primary" },
                on: {
                  click: function ($event) {
                    return _setup.onStoresDropdownClick()
                  },
                },
              },
              _vm._l(_setup.filteredStores, function (store) {
                return _c(
                  "b-dropdown-item",
                  {
                    key: store.Id,
                    attrs: {
                      active: _setup.storeUrl == store.Url,
                      value: store.Url,
                    },
                    on: {
                      click: function ($event) {
                        return _setup.setStoreUrl(store.Url)
                      },
                    },
                  },
                  [_c("div", [_vm._v(_vm._s(store.Url))])]
                )
              }),
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    (!_vm.stores || !_vm.stores.length) && _vm.noStoresText
      ? _c("div", [
          _c("div", { staticClass: "mb-1" }, [
            _c("b", [_vm._v(_vm._s(_vm.noStoresText))]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }